<script setup lang="ts">
import { type Color } from '@global-types/colors';
import type { FontVariant } from '@global-types/fontVariant';

type Tag = 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4';

withDefaults(defineProps<{
  variant: FontVariant,
  color?: Color,
  as?: Tag,
  fontInherit?: boolean,
}>(), {
  color: 'black',
  as: 'p',
  fontInherit: false,
});
</script>

<template>
  <component
    :is="as"
    class="typography"
    :class="[
      `typography--${variant}`,
      `typography--color-${color}`,
      { 'typography--font-inherit': fontInherit }
    ]"
  >
    <slot />
  </component>
</template>
